"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authUserProfileRefreshed = exports.authTokenExpired = exports.authTokenExpiring = exports.authTokenUpdated = void 0;
const core_utility_1 = require("@built/core-utility");
/**
 * Handle in apps to receive notifications when auth token changes.
 * */
exports.authTokenUpdated = new core_utility_1.TrackedEvent('built/auth/tokenUpdated');
/**
 * Handle in apps to receive notifications when auth token is about to expire, based on the configured expiration monitor threshold.
 *
 * The token provided is the current (expiring) token data, not the new token.
 */
exports.authTokenExpiring = new core_utility_1.TrackedEvent('built/auth/tokenExpired');
/**
 * Handle in apps to receive notifications when auth token has expired.
 *
 * The token provided is the current (expired) token data, not the new token.
 */
exports.authTokenExpired = new core_utility_1.TrackedEvent('built/auth/tokenExpired');
/**
 * Handle in apps to receive notifications when auth user profile has been refreshed.
 *
 * Will send the last notified profile on subscribe.
 *
 * See the `reason` property on the event data for the reason the profile was refreshed.
 *
 * **It is on consuming apps to determine if the profile has _changed_ in a way that matters to them.**
 */
exports.authUserProfileRefreshed = new core_utility_1.TrackedEvent('built/auth/userProfileRefreshed', {
    sendLatestOnSubscribe: true,
});
